import { AfterViewInit, Directive, ElementRef, Input, Renderer2, SimpleChanges, ViewChild } from '@angular/core';

@Directive({
  selector: '[headerCollapseExpand]'
})
/**
 * This directive expand/collapse the title/search section of the header
 */
export class HeaderCollapseExpandDirective implements AfterViewInit {
  @Input() headerCollapseExpand:boolean;//Whether the search container is expanded or not. false == collapsed

  title:ElementRef;
  search:ElementRef;

  constructor(private el: ElementRef, 
    private renderer: Renderer2) { }


  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    setTimeout(() => {
      this.title = this.el.nativeElement.querySelector(".header-entity-title");
      this.search = this.el.nativeElement.querySelector(".header-search-container");
      this.toggle();
    }, 10);
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["headerCollapseExpand"]){
      if(this.title && this.search){
        this.toggle();
      }
    }
  }
  toggle():void{
    this.headerCollapseExpand? this.expandSearch() : this.collapseSearch();
  }

  expandSearch():void{
    this.renderer.addClass(this.search,"expanded");
    this.renderer.removeClass(this.search,"collapsed");
    this.renderer.addClass(this.title,"collapsed");
    this.renderer.removeClass(this.title,"expanded")
  }

  collapseSearch():void{
    this.renderer.removeClass(this.search,"expanded");
    this.renderer.addClass(this.search,"collapsed");
    this.renderer.removeClass(this.title,"collapsed");
    this.renderer.addClass(this.title,"expanded")
  }
}
